<template>
    <a-modal v-model="visible" :title="title" :footer="null" width="83%">
        <a-spin :spinning="loading">
            <div class="contract-box" v-html="artcCntnt">
            </div>
        </a-spin>
    </a-modal>
</template>
<script>
export default {
    props:["title","artcCntnt"],
    name:"userService",
    data() {
        return {
            visible:false,
            loading:false,
        };
    },
    computed: {},
    methods: {
        open(){
            this.visible = true;
        },
        close(){
            this.visible = false;
        },
    },
    watch:{
    }
}
</script>
<style scoped>
.contract-box{
    width: 86%;
    min-height: 60vh;
    margin:0 auto;
    border: #e9ebee 1px solid;
    margin-top: 30px;
    padding: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/components/table-find-rcvb/fileView.vue